module.exports = __webpack_public_path__ + "static/media/sent.4d11c13a.svg";